import React from 'react';
import { Box } from '@mui/material';
import Header from './widgets/Header';
import PlatformsList from './widgets/PlatformsList';

function Platforms({ user, setUser, handleMenuSelection }) {

    return (
        <PlatformsList user={user} setUser={setUser} handleMenuSelection={handleMenuSelection}/>
    );
}

export default Platforms;